import { css } from "styled-components";
import { riotProductSkin } from "../riot-product";
export const valorantSkin = (chroma, paletteTokens) => css `
  ${riotProductSkin(chroma, paletteTokens)}

  .gradient-container {
    height: 100%;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    background: linear-gradient(0deg, rgb(15 25 35 / 40%), rgb(15 25 35 / 40%)),
      radial-gradient(35.52% 56.1% at 50% 50%, rgb(15 25 35 / 50%) 0%, rgb(15 25 35 / 0%) 100%);
  }
`;
//# sourceMappingURL=index.js.map